/* @ngInject */
export default function StepFileService() {
    return {
        isStepFileAvailable: function (uniquePart) {
            if (uniquePart.parameterValues === undefined) return false;
            for (let i = 0; i < uniquePart.parameterValues.length; ++i) {
                if (uniquePart.parameterValues[i].parameterName === 'STEP') {
                    return true;
                }
            }
            return false;
        }
    };
}
